var map = {
	"./logo_pl_de.svg": 28245,
	"./logo_pl_fr.svg": 20964,
	"./logo_pl_invert_de.svg": 18134,
	"./logo_pl_invert_fr.svg": 99171,
	"./logo_pl_invert_nl.svg": 2253,
	"./logo_pl_nl.svg": 73114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4820;